import { useEffect, useState } from 'react'

import { Button, Alert, IconButton } from '@mui/material';

import Latex from 'react-latex-next';

import { useContext } from 'react';
import { SocketContext } from "../../../context/SocketContext";
import { useDispatch } from 'react-redux';
import { AppDispatch } from '../../../store';
// import { actualizarEjercicio } from '../../../store/slices/ejercicio';

// mui icons
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { EjercicioState } from '../../../store/slices/ejercicio';

type Props = {
    index: number
    ejercicio: EjercicioState
    handleEliminarEjercicio: Function
    handleEditarEjercicio: Function
}

type State = {
    ok: null | Boolean
    title: string
    msg: string
}

const FormularioSMEdicion = ({ index, ejercicio, handleEliminarEjercicio, handleEditarEjercicio }: Props) => {

    const { eid, enunciado, alternativas } = ejercicio;

    const [respuestaUsuario, setRespuestaUsuario] = useState({ letra: '', alternativa: '', estado: null });
    const [state, setState] = useState<State>({
        ok: null,
        title: '',
        msg: ''
    });

    const [alert, setAlert] = useState(false);

    useEffect(() => {
        if (alert) {
            const timer = setTimeout(() => { setAlert(false); }, 5000);
            return () => clearTimeout(timer);
        }
    }, [alert]);

    // PENDIENTE
    // useEffect(() => {
    //     if (state.ok !== null) {
    //         // console.log('Hacer algo')
    //         socket?.emit('actualizar-ejercicio', {eid: eid, estado: state.ok});
    //         dispatch(actualizarEjercicio(eid, state.ok))
    //     }
    // }, [state, eid, socket, dispatch])


    const handleRespuesta = () => {

        if (respuestaUsuario.estado === null) {
            setAlert(true);
            setState({
                ok: null,
                title: '¡Cuidado!',
                msg: 'No has seleccionado una alternativa'
            });
        }

        if (respuestaUsuario.estado === true) {
            setAlert(true);
            setState({
                ok: respuestaUsuario.estado,
                title: '¡Felicitaciones!',
                msg: 'Has seleccionado la alternativa correcta'
            });
        }

        if (respuestaUsuario.estado === false) {
            setAlert(true);
            setState({
                ok: respuestaUsuario.estado,
                title: '¡Sigue intentando!',
                msg: 'Has seleccionado una alternativa equivocada'
            });
        }
    }

    return (
        <>
            <div className='card mb-5'>
                <div className="card-header py-2">
                    <div className="row justify-content-between align-items-center">
                        <div className="col-auto">
                            Ejercicio {index + 1}
                        </div>
                        <div className="col-auto">
                            <IconButton
                                onClick={() => handleEditarEjercicio(ejercicio)}
                                size='small'
                            >
                                <EditIcon fontSize="inherit" />
                            </IconButton>

                            <IconButton
                                onClick={() => handleEliminarEjercicio(ejercicio)}
                                size='small'
                            >
                                <DeleteIcon fontSize="inherit" />
                            </IconButton>
                        </div>
                    </div>
                </div>
                <div className="card-body">
                    <Latex>{`${enunciado}`}</Latex>
                </div>
                {
                    alternativas.map((item: any, key: number) => {
                        const { alternativa } = item;

                        return alternativa && (
                            <div key={key}>
                                <hr style={{ marginTop: '0px', marginBottom: '0px' }} />
                                <div
                                    className='card-body d-flex align-items-center'
                                    style={{ padding: '1rem', paddingLeft: '0.5rem', minHeight: '60px' }}
                                >
                                    <input
                                        className='mx-2 align-text-bottom'
                                        type="radio"
                                        name={eid}
                                        onChange={() => setRespuestaUsuario(item)}
                                    />
                                    <Latex>
                                        {item.alternativa}
                                    </Latex>
                                </div>
                            </div>
                        )
                    })
                }

                <div className="card-footer">
                    <div className="row">
                        <div className="col-12">
                            <Button
                                className='float-end'
                                sx={{ margin: 0 }}
                                size="small"
                                color="primary"
                                variant="outlined"
                                onClick={() => handleRespuesta()}
                                aria-label="close"
                                disabled={alert}
                            >
                                Revisar
                            </Button>
                        </div>
                    </div>
                    <div className="row align-items-center">
                        <div className="col-12">
                            {
                                alert &&
                                <Alert
                                    severity={state.ok === null ? 'info' : (state.ok ? 'success' : 'error')}
                                    sx={{ position: 'relative', mt: 1 }}
                                >
                                    {state.title} {state.msg}
                                </Alert>
                            }
                        </div>
                    </div>
                </div>


            </div>
        </>
    )
}

export default FormularioSMEdicion;